// extracted by mini-css-extract-plugin
export var category = "ListItemPost-module--category--6ec80";
export var date = "ListItemPost-module--date--8bb11";
export var featuredImageContainer = "ListItemPost-module--featuredImageContainer--5f29a";
export var listItemPost = "ListItemPost-module--listItemPost--f15fe";
export var postText = "ListItemPost-module--postText--b3d71";
export var title = "ListItemPost-module--title--fc75a";